import JSZip from 'jszip';

/**
 * 下载 Excel 文件
 * @param {string} base64ExcelData - Base64 编码的 Excel 数据
 * @param {string} fileName - 文件名
 */
export const DownloadExcel = (base64ExcelData, fileName = '结果表格') => {
  const raw = window.atob(base64ExcelData);
  const uInt8Array = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) {
    uInt8Array[i] = raw.charCodeAt(i);
  }
  const link = document.createElement('a');
  const blob = new Blob([uInt8Array], {
    type: 'application/vnd.ms-excel',
  });
  link.style.display = 'none';
  link.href = URL.createObjectURL(blob);
  link.setAttribute('download', `${fileName}.xlsx`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

/**
 * 下载 Markdown 文件
 * @param {string} base64ExcelData - Base64 编码的数据
 * @param {string} type - 文件类型 (md/zip)
 * @param {string} fileName - 文件名
 */
export const DownloadMd = (base64ExcelData, type, fileName) => {
  const raw = window.atob(base64ExcelData);
  const uInt8Array = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) {
    uInt8Array[i] = raw.charCodeAt(i);
  }
  const link = document.createElement('a');
  const blob = new Blob([uInt8Array], {
    type: type === 'zip' ? 'data:application/zip;base64' : 'data:text/markdown;base64',
  });

  link.style.display = 'none';
  link.href = URL.createObjectURL(blob);
  link.setAttribute('download', `${fileName}.${type}`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

/**
 * 下载 Markdown + 图片资源的 ZIP 包
 * @param {string} MarkdownBase64 - Base64 编码的 Markdown 内容
 * @param {string} InsetImagePackage - Base64 编码的图片包
 */
export const DownloadMpZip = (MarkdownBase64, InsetImagePackage) => {
  const getBlob = (base64, type) => {
    const raw = window.atob(base64);
    const uInt8Array = new Uint8Array(raw.length);
    for (let i = 0; i < raw.length; i++) {
      uInt8Array[i] = raw.charCodeAt(i);
    }
    const blob = new Blob([uInt8Array], {
      type: type
    });
    return blob;
  };
  const zip = new JSZip();
  zip.file('myBlog.md', getBlob(MarkdownBase64, 'data:text/markdown;base64'));
  zip.file('myBlog.zip', getBlob(InsetImagePackage, 'data:application/zip;base64'));
  zip.generateAsync({ type: 'blob' }).then(blob => {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'file.zip';
    link.click();
  }).catch(() => {
    alert('错误');
  });
};
